export const id = (photo) => photo.id;

export const src = (photo) => photo.full_path;

const determineType = (photo) => {
  if (photo.image_type === '360_DEGREE') return '360';
  if (photo.full_path.split('.').pop().toLowerCase() === 'mp4') return 'video';
  return 'regular';
};

export const viewModel = (
  photo,
  { watermarkSrc = null, canDownload = false, canShare = false, canSelect = true, canFavorite = false } = {}
) => ({
  id: id(photo),
  type: determineType(photo),
  src: photo.thumb_full_path,
  watermarkSrc,
  canSelect,
  canDownload,
  canShare,
  canFavorite,
  isFavorite: Boolean(photo?.is_favorite),
});

export const fullScreenVM = (photo, { watermarkSrc = null, canShare = false, canDownload = false }) => ({
  id: id(photo),
  type: determineType(photo),
  src: photo.full_path,
  watermarkSrc,
  canShare,
  canDownload,
});

export const isPhotoById = (photoId) => (photo) => id(photo) === photoId;

export const isStockImage = ({ stock_image_uid: stockImageUid }) =>
  stockImageUid !== null && stockImageUid !== undefined;

export const includesById = (ids) => (photo) => ids.includes(id(photo));

export const notIncludesById = (ids) => (photo) => !includesById(ids)(photo);
